import { takeLatest } from "redux-saga/effects";

import { FETCH_CAR_EXTRA_INFO } from "../actions/constants";
import { fetchCarShopSaga } from "./fetchCarShopSaga";

export function* watchFetchCarsShopSaga() {
  yield takeLatest(FETCH_CAR_EXTRA_INFO, fetchCarShopSaga);
}
